import { UserReviewRefineSearchJsEnv, QueryParameter, RefineSearchParameter } from "./user_review_refine_search_js_env"

export class UserReviewRefineSearch {
  constructor(private model: UserReviewRefineSearchJsEnv) {
    this.model = { ...model }
  }

  getModel(): UserReviewRefineSearchJsEnv {
    return {
      ...this.model
    }
  }

  getRefineSearchParameter(): RefineSearchParameter {
    return {
      ...this.model.refineSearchParameter
    }
  }

  updateSearchParameterFromPopstateEvent(refineSearchParameter: RefineSearchParameter) {
    this.model.refineSearchParameter = refineSearchParameter;
  }

  updateSearchParameter(newParameters: QueryParameter[]) {

    for (const newParameter of newParameters) {
      const key = newParameter.key;
      const newValue = newParameter.value;
      const currentValue = this.model.refineSearchParameter[key];

      if (key === 'page' || key === 'sort' || key === 'rate') {
        this.model.refineSearchParameter[key] = Number(newValue);
        continue;
      }

      if (currentValue) {
        this.model.refineSearchParameter[key] = null;
      } else {
        this.model.refineSearchParameter[key] = newValue;
      }
    }
  }

  updateHtmlForRender(htmlForRender: Document) {
    this.model.htmlForRender = htmlForRender;
  }

  updateSelfLink(newSelfLink: string) {
    this.model.selfLink = newSelfLink;
  }

  createSearchUrl() {
    const searchParameters = (this.model.selfLink ?? '') + '?';
    const parameterKeyValueList: string[] = [];

    Object.keys(this.model.refineSearchParameter).forEach((key) => {
      const newValue = this.model.refineSearchParameter[key];
      const isMultipleValue = Array.isArray(newValue);
      if (isMultipleValue) {
        parameterKeyValueList.push(...newValue.map(v => key.concat('=', this.convertNullToEmptyString(v)))); // NOSONAR
      } else {
        parameterKeyValueList.push(key.concat('=', this.convertNullToEmptyString(newValue)));
      }
    })

    return searchParameters.concat(parameterKeyValueList.join('&'));
  }

  convertNullToEmptyString(valueToConvert: string) {
    return String(valueToConvert) === 'null' ? '' : valueToConvert;
  }

  getLoadingSpinnerHtml() {
    const loadingSpinnerOverlay = document.createElement('div');
    loadingSpinnerOverlay.setAttribute('style', 'position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 9999; background-color: rgba(255, 255, 255, 0.7);');
    loadingSpinnerOverlay.id = 'user_review_refine_search_loading_spinner';

    const loadingSpinnerContainer = document.createElement('div');
    loadingSpinnerContainer.setAttribute('style', 'position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; margin: auto;');
    loadingSpinnerContainer.className = 'a-spinner';

    const loadingSpinner = document.createElement('div');
    loadingSpinner.className = 'a-spinner_inner';

    loadingSpinnerOverlay.append(loadingSpinnerContainer);
    loadingSpinnerContainer.append(loadingSpinner);
    return loadingSpinnerOverlay;
  }

  showLoadingSpinner() {
    const loadingSpinner = this.getLoadingSpinnerHtml();
    document.body.append(loadingSpinner);
  }

  hideLoadingSpinner() {
    document.getElementById('user_review_refine_search_loading_spinner')?.remove();
  }
}
